/**
 * Shared date formatting helpers.
 *
 * `formatShortDate` and `formatRelativeDay` accept a `YYYY-MM-DD` string
 * and parse it as local midnight (by appending `T00:00:00`) to avoid the
 * UTC off-by-one issue that bare `new Date("2026-03-14")` introduces.
 */

export function formatShortDate(dateStr: string): string {
  return new Date(dateStr + "T00:00:00").toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
}

export function formatRelativeDay(dateStr: string): string {
  const date = new Date(dateStr + "T00:00:00");
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diffDays = Math.round((today.getTime() - date.getTime()) / 86_400_000);
  if (diffDays <= 0) return "today";
  if (diffDays === 1) return "yesterday";
  if (diffDays < 14) return `${diffDays}d ago`;
  const weeks = Math.floor(diffDays / 7);
  if (weeks < 8) return `${weeks}w ago`;
  return formatShortDate(dateStr);
}

export function formatLongDate(date: Date = new Date()): string {
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}
